import { create } from 'zustand';
import type { PublicKey } from '@shared/types';

export type PublishedIdentity = {
  identityId: string;
  identityName: string | null;
  publicKey: PublicKey;
};

interface PublishedIdentitiesState {
  byServerId: Record<string, PublishedIdentity[]>;
  setPublished: (serverId: string, identities: PublishedIdentity[]) => void;
  clearPublished: (serverId: string) => void;
}

export const usePublishedIdentitiesStore = create<PublishedIdentitiesState>((set) => ({
  byServerId: {},
  setPublished: (serverId, identities) =>
    set((state) => ({
      byServerId: {
        ...state.byServerId,
        [serverId]: identities
      }
    })),
  clearPublished: (serverId) =>
    set((state) => {
      const next = { ...state.byServerId };
      delete next[serverId];
      return { byServerId: next };
    })
}));
